import { AxiosResponse } from "axios";
import api from "../apiService";
import {
	CollaboratorAppoimentsQuery,
	DataUpdateColabborator,
	CollaboratorFilter,
} from "features/affiliate/collaborators/type";

export const getCollaboratorsAPI = async (query: CollaboratorFilter) =>
	new Promise((resolve, reject) => {
		const endpoint = "/dashboard-affiliates/collaborators";
		const payload = JSON.parse(JSON.stringify(query));
		payload.skip = payload.skip * (payload.take ?? 0);
		if (payload.fullName === "") payload.fullName = null;
		if (payload.email === "") payload.email = null;
		if (payload.fullName) {
			payload.fullName = payload.fullName.replace(/[\*\(\)]/g, "#");
		}
		api
			.get(endpoint, payload)
			.then(result => resolve(result))
			.catch(error => reject(error));
	});

export const _getCollaboratorsAPI = async (query: CollaboratorFilter) =>
	new Promise((resolve, reject) => {
		const endpoint = "/dashboard-affiliates/collaborators";
		const payload = JSON.parse(JSON.stringify(query));
		payload.skip = payload.skip * (payload.take ?? 0);
		if (payload.fullName === "") payload.fullName = null;
		if (payload.email === "") payload.email = null;
		api
			.get(endpoint, payload)
			.then(result => resolve(result.data))
			.catch(error => reject(error));
	});

export const getCollaboratorAPI = async (id: string) =>
	new Promise((resolve, reject) => {
		api
			.get(`/dashboard-affiliates/collaborators/${id}`)
			.then(result => resolve(result.data))
			.catch(error => reject(error));
	});

export const updateCollaboratorAPI = async (data: DataUpdateColabborator) =>
	new Promise((resolve, reject) => {
		try {
			const payload = JSON.parse(JSON.stringify(data));
			if (payload.bankName) {
				payload.bankNameId = payload.bankName.id;
			}
			api
				.patch(`/dashboard-affiliates/collaborators/${data._id}`, payload)
				.then(result => resolve(result.data))
				.catch(error => reject(error));
		} catch (error) {
			console.log(error);
			reject({ message: "An error occurred during processing." });
		}
	});

export const getCollaboratorAppointmentsAPI = ({
	query,
	id,
}: {
	query: CollaboratorAppoimentsQuery;
	id: string;
}): Promise<any> =>
	new Promise(async (resolve, reject) => {
		const payload = JSON.parse(JSON.stringify(query));
		payload.skip = payload.skip * payload.take;
		try {
			const path = "/dashboard/bookings";
			const response: AxiosResponse = await api.get(path, {
				...payload,
				collaboratorId: id,
			});
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});

export const getCollaboratorPurchasesAPI = ({
	query,
	id,
}: {
	query: CollaboratorAppoimentsQuery;
	id: string;
}): Promise<any> =>
	new Promise(async (resolve, reject) => {
		const payload = JSON.parse(JSON.stringify(query));
		payload.skip = payload.skip * payload.take;
		try {
			const path = "/dashboard/purchase-orders";
			const response: AxiosResponse = await api.get(path, {
				...payload,
				collaboratorId: id,
			});
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});

export const getRejectReasonsAPI = ({ lang }: { lang: string }): Promise<any> =>
	new Promise(async (resolve, reject) => {
		const path = "/common-configurations/reason-reject";
		await api
			.get(path, { language: lang })
			.then(result => resolve(result.data))
			.catch(error => reject(error));
	});

export const getBlockReasonsAPI = ({ lang }: { lang: string }): Promise<any> =>
	new Promise(async (resolve, reject) => {
		const path = "/common-configurations/reason-block";
		await api
			.get(path, { language: lang })
			.then(result => resolve(result.data))
			.catch(error => reject(error));
	});

export const rejectCollaboratorAPI = ({
	id,
	reason,
}: {
	id: string;
	reason: {
		message: string;
		samepleId: string;
	};
}): Promise<any> =>
	new Promise(async (resolve, reject) => {
		const path = `/dashboard-affiliates/collaborators/${id}/reject`;
		await api
			.post(path, reason)
			.then(result => resolve(result.data))
			.catch(error => reject(error));
	});

export const blockCollaboratorAPI = ({
	id,
	reason,
}: {
	id: string;
	reason: {
		message: string;
		samepleId: string;
	};
}): Promise<any> =>
	new Promise(async (resolve, reject) => {
		const path = `/dashboard-affiliates/collaborators/${id}/block`;
		await api
			.post(path, reason)
			.then(result => resolve(result.data))
			.catch(error => reject(error));
	});

export const approveCollaboratorAPI = ({ id }: { id: string }): Promise<any> =>
	new Promise(async (resolve, reject) => {
		const path = `/dashboard-affiliates/collaborators/${id}/approve`;
		await api
			.post(path, {})
			.then(result => resolve(result.data))
			.catch(error => reject(error));
	});
